/**
 * Module for V1 Product role enums.
 * This contains the product role enums extracted from rolesV1.ts
 * until we remove this module (see the comment below)
 * @module productRolesV1
 * @deprecated This should be removed after the migration from static Org
 * roles for SSO to Org roles in Teams is complete.
 * Jira task for roles removal: https://taktak.atlassian.net/browse/PLAT-8542
 */

export enum EdgeRole {
  ADMIN = 'edge_admin',
  EDITOR = 'edge_editor',
  READER = 'edge_reader',
  USER = 'edge_user',
  NOACCESS = 'edge_noaccess',
}

export enum StreamRole {
  ADMIN = 'stream_admin',
  EDITOR = 'stream_editor',
  READER = 'stream_reader',
  USER = 'stream_user',
  NOACCESS = 'stream_noaccess',
}

export enum SearchRole {
  ADMIN = 'search_admin',
  EDITOR = 'search_editor',
  USER = 'search_user',
  NOACCESS = 'search_noaccess',
}

export enum LakeRole {
  ADMIN = 'lake_admin',
  EDITOR = 'lake_editor',
  READER = 'lake_reader',
  NOACCESS = 'lake_noaccess',
}
